module.exports = __webpack_public_path__ + "img/microfocus-small.459c2b39.png";